import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_6 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_7 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_8 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_9 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_12 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_13 = { class: "d-flex align-items-center gap-2" }
const _hoisted_14 = {
  key: 0,
  class: "material-symbols-outlined fs-24 text-primary"
}
const _hoisted_15 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_16 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_17 = { class: "d-flex flex-wrap gap-4 mb-2" }
const _hoisted_18 = { class: "form-check" }
const _hoisted_19 = { class: "form-check" }
const _hoisted_20 = { class: "form-check" }
const _hoisted_21 = {
  key: 0,
  class: "p-3 border rounded bg-light mt-2"
}
const _hoisted_22 = { class: "row g-2" }
const _hoisted_23 = { class: "form-check" }
const _hoisted_24 = ["id", "value"]
const _hoisted_25 = ["for"]
const _hoisted_26 = {
  key: 0,
  class: "text-danger fs-12 mt-2"
}
const _hoisted_27 = { class: "col-lg-6 col-md-6 mb-4 d-flex align-items-center" }
const _hoisted_28 = { class: "form-check form-switch mt-2 me-4" }
const _hoisted_29 = { class: "form-check form-switch mt-2" }
const _hoisted_30 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_31 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_32 = { class: "form-label text-dark fs-14 fw-medium d-flex justify-content-between align-items-center" }
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = ["onClick", "disabled"]
const _hoisted_35 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_36 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_37 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_38 = { class: "fw-semibold fs-14" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "row g-2" }
const _hoisted_41 = { class: "col-sm-2" }
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = { class: "col-sm-2" }
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = { class: "col-sm-2" }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = { class: "col-sm-2" }
const _hoisted_48 = ["onUpdate:modelValue"]
const _hoisted_49 = { class: "col-sm-2" }
const _hoisted_50 = ["onUpdate:modelValue"]
const _hoisted_51 = { class: "col-sm-2" }
const _hoisted_52 = ["onUpdate:modelValue"]
const _hoisted_53 = { class: "col-sm-12 mt-2 d-flex align-items-end" }
const _hoisted_54 = { class: "form-check form-switch mb-1" }
const _hoisted_55 = ["id", "onUpdate:modelValue"]
const _hoisted_56 = ["for"]
const _hoisted_57 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: _ctx.isEditing ? 'Edit Package' : 'Add Package',
      subTitle: "Management"
    }, null, 8, ["pageTitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Package Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.package_name) = $event)),
                placeholder: "Enter package name",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.package_name]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Price (Rp)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.price) = $event)),
                placeholder: "0",
                min: "0",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.price]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Discount (Rp)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.discount) = $event)),
                placeholder: "0",
                min: "0"
              }, null, 512), [
                [_vModelText, _ctx.form.discount]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Urutan Tampil (Sort Order)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.sort_order) = $event)),
                placeholder: "0",
                min: "0"
              }, null, 512), [
                [_vModelText, _ctx.form.sort_order]
              ]),
              _cache[22] || (_cache[22] = _createElementVNode("small", { class: "text-muted" }, "Angka lebih kecil tampil lebih awal (default 0).", -1))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Services Included", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                multiple: "",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.service_ids) = $event)),
                style: {"height":"120px"},
                required: ""
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableServices, (service) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: service.service_id,
                    value: service.service_id
                  }, _toDisplayString(service.service_name) + " (Rp " + _toDisplayString(Number(service.base_price).toLocaleString('id-ID')) + ") ", 9, _hoisted_10))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.form.service_ids]
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("small", { class: "text-muted" }, "Hold Ctrl/Cmd to select multiple services", -1))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Unit", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.unit) = $event)),
                placeholder: "e.g. per paket, per akun"
              }, null, 512), [
                [_vModelText, _ctx.form.unit]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[27] || (_cache[27] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Material Icon", -1)),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.icon) = $event))
                }, _cache[26] || (_cache[26] = [
                  _createStaticVNode("<option value=\"\">-- No Icon --</option><option value=\"plagiarism\">Plagiarism</option><option value=\"edit_document\">Edit Document</option><option value=\"auto_fix_high\">Auto Fix High</option><option value=\"menu_book\">Menu Book (Journal)</option><option value=\"translate\">Translate</option><option value=\"school\">School / Tutorial</option><option value=\"info\">Info</option><option value=\"check_circle\">Check Circle</option><option value=\"upload_file\">Upload File</option><option value=\"contact_support\">Contact Support</option><option value=\"inventory_2\">Package / Bundle</option><option value=\"description\">Description</option><option value=\"verified\">Verified</option><option value=\"star\">Star</option>", 15)
                ]), 512), [
                  [_vModelSelect, _ctx.form.icon]
                ]),
                (_ctx.form.icon)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.form.icon), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[28] || (_cache[28] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Navigation Link", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.link) = $event)),
                placeholder: "e.g. /paket-all-in-one"
              }, null, 512), [
                [_vModelText, _ctx.form.link]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[33] || (_cache[33] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Status Akses / Eksklusivitas Kampus Mitra", -1)),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    id: "pkg_exc_none",
                    value: "none",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.exclusivityMode) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.exclusivityMode]
                  ]),
                  _cache[29] || (_cache[29] = _createElementVNode("label", {
                    class: "form-check-label text-dark fs-13",
                    for: "pkg_exc_none"
                  }, [
                    _createElementVNode("strong", null, "Umum"),
                    _createTextVNode(" (Terbuka untuk semua pengguna & publik) ")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    id: "pkg_exc_all",
                    value: "all",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.exclusivityMode) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.exclusivityMode]
                  ]),
                  _cache[30] || (_cache[30] = _createElementVNode("label", {
                    class: "form-check-label text-dark fs-13",
                    for: "pkg_exc_all"
                  }, [
                    _createElementVNode("strong", null, "Eksklusif Seluruh Kampus Mitra"),
                    _createTextVNode(" (Semua mitra terdaftar di RayaCheck) ")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    id: "pkg_exc_specific",
                    value: "specific",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.exclusivityMode) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.exclusivityMode]
                  ]),
                  _cache[31] || (_cache[31] = _createElementVNode("label", {
                    class: "form-check-label text-dark fs-13",
                    for: "pkg_exc_specific"
                  }, [
                    _createElementVNode("strong", null, "Eksklusif Kampus Tertentu"),
                    _createTextVNode(" (Pilih satu atau beberapa kampus) ")
                  ], -1))
                ])
              ]),
              (_ctx.exclusivityMode === 'specific')
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _cache[32] || (_cache[32] = _createElementVNode("label", { class: "form-label text-dark fs-13 fw-semibold mb-2" }, "Pilih Kampus Mitra yang Memiliki Akses:", -1)),
                    _createElementVNode("div", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: partner.id,
                          class: "col-md-4 col-sm-6"
                        }, [
                          _createElementVNode("div", _hoisted_23, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              id: 'pkg_partner_' + partner.id,
                              value: partner.id,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedPartnerIds) = $event))
                            }, null, 8, _hoisted_24), [
                              [_vModelCheckbox, _ctx.selectedPartnerIds]
                            ]),
                            _createElementVNode("label", {
                              class: "form-check-label fs-13",
                              for: 'pkg_partner_' + partner.id
                            }, _toDisplayString(partner.name), 9, _hoisted_25)
                          ])
                        ]))
                      }), 128))
                    ]),
                    (_ctx.selectedPartnerIds.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, " * Harap pilih minimal 1 kampus mitra. "))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "isActive",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.is_active) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.is_active]
                ]),
                _cache[34] || (_cache[34] = _createElementVNode("label", {
                  class: "form-check-label text-dark fs-14 fw-medium",
                  for: "isActive"
                }, "Active (Visible to users)", -1))
              ]),
              _createElementVNode("div", _hoisted_29, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "featured",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.featured) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.featured]
                ]),
                _cache[35] || (_cache[35] = _createElementVNode("label", {
                  class: "form-check-label text-dark fs-14 fw-medium",
                  for: "featured"
                }, "Featured Package", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Description", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.description) = $event)),
                rows: "3",
                placeholder: "Enter package description"
              }, null, 512), [
                [_vModelText, _ctx.form.description]
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("label", _hoisted_32, [
                _cache[38] || (_cache[38] = _createElementVNode("span", null, "Features / Benefits (Bullet points)", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-outline-primary py-1 px-2",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.addFeature && _ctx.addFeature(...args)))
                }, _cache[37] || (_cache[37] = [
                  _createElementVNode("i", { class: "ri-add-line me-1" }, null, -1),
                  _createTextVNode("Add Feature ")
                ]))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.features, (feat, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "d-flex mb-2 align-items-center gap-2"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": ($event: any) => ((_ctx.form.features[index]) = $event),
                    placeholder: "Enter benefit bullet point",
                    required: ""
                  }, null, 8, _hoisted_33), [
                    [_vModelText, _ctx.form.features[index]]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-danger p-2 lh-1",
                    onClick: ($event: any) => (_ctx.removeFeature(index)),
                    disabled: _ctx.form.features.length <= 1
                  }, _cache[39] || (_cache[39] = [
                    _createElementVNode("i", { class: "material-symbols-outlined fs-18" }, "delete", -1)
                  ]), 8, _hoisted_34)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _cache[41] || (_cache[41] = _createElementVNode("h5", { class: "mb-0 fs-15 text-dark" }, "Price Tiers (Quantity-based Pricing)", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-outline-primary py-1 px-2",
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.addTier && _ctx.addTier(...args)))
                }, _cache[40] || (_cache[40] = [
                  _createElementVNode("i", { class: "ri-add-line me-1" }, null, -1),
                  _createTextVNode("Add Tier ")
                ]))
              ]),
              _cache[49] || (_cache[49] = _createElementVNode("div", { class: "alert alert-info fs-13 py-2 mb-3" }, [
                _createElementVNode("i", { class: "ri-information-line me-1" }),
                _createTextVNode(" Define pricing tiers based on quantity/page count. If no tiers are added, the base price will be used. Leave \"Max Qty\" empty for open-ended tiers. ")
              ], -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.price_tiers, (tier, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "p-3 border rounded-3 mb-3 bg-light"
                }, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("span", _hoisted_38, "Tier #" + _toDisplayString(index + 1), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-outline-danger py-0 px-2",
                      onClick: ($event: any) => (_ctx.removeTier(index))
                    }, _cache[42] || (_cache[42] = [
                      _createElementVNode("i", { class: "ri-delete-bin-line fs-14" }, null, -1)
                    ]), 8, _hoisted_39)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _cache[43] || (_cache[43] = _createElementVNode("label", { class: "form-label fs-13 mb-1" }, [
                        _createTextVNode("Min Qty "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": ($event: any) => ((tier.min_qty) = $event),
                        required: "",
                        min: "1"
                      }, null, 8, _hoisted_42), [
                        [
                          _vModelText,
                          tier.min_qty,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _cache[44] || (_cache[44] = _createElementVNode("label", { class: "form-label fs-13 mb-1" }, "Max Qty", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": ($event: any) => ((tier.max_qty) = $event),
                        placeholder: "∞"
                      }, null, 8, _hoisted_44), [
                        [
                          _vModelText,
                          tier.max_qty,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _cache[45] || (_cache[45] = _createElementVNode("label", { class: "form-label fs-13 mb-1" }, [
                        _createTextVNode("Price (Rp) "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": ($event: any) => ((tier.price) = $event),
                        required: "",
                        min: "0",
                        step: "1000"
                      }, null, 8, _hoisted_46), [
                        [
                          _vModelText,
                          tier.price,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _cache[46] || (_cache[46] = _createElementVNode("label", { class: "form-label fs-13 mb-1" }, "Discount (Rp)", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": ($event: any) => ((tier.discount) = $event),
                        min: "0",
                        step: "1000"
                      }, null, 8, _hoisted_48), [
                        [
                          _vModelText,
                          tier.discount,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _cache[47] || (_cache[47] = _createElementVNode("label", { class: "form-label fs-13 mb-1" }, "Label", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": ($event: any) => ((tier.label) = $event),
                        placeholder: "e.g. 1-10 Halaman"
                      }, null, 8, _hoisted_50), [
                        [_vModelText, tier.label]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _cache[48] || (_cache[48] = _createElementVNode("label", { class: "form-label fs-13 mb-1" }, "Deadline", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": ($event: any) => ((tier.deadline) = $event),
                        placeholder: "e.g. 3-5 Hari"
                      }, null, 8, _hoisted_52), [
                        [_vModelText, tier.deadline]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          id: 'tierActive'+index,
                          "onUpdate:modelValue": ($event: any) => ((tier.is_active) = $event)
                        }, null, 8, _hoisted_55), [
                          [_vModelCheckbox, tier.is_active]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label fs-12",
                          for: 'tierActive'+index
                        }, "Active", 8, _hoisted_56)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createVNode(_component_RouterLink, {
              to: "/packages",
              class: "btn btn-secondary fs-15 fw-medium"
            }, {
              default: _withCtx(() => _cache[50] || (_cache[50] = [
                _createTextVNode("Cancel")
              ])),
              _: 1
            }),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary fs-15 fw-medium",
              disabled: _ctx.loading
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_59))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? 'Update Package' : 'Create Package'), 1)
            ], 8, _hoisted_58)
          ])
        ], 32)
      ])
    ])
  ]))
}